import * as React from "react";
import Card from 'react-bootstrap/Card';
import {Button} from "react-bootstrap";
import TextareaAutosize from 'react-textarea-autosize';

interface Props {
  notes: string;
}

interface State {
  editing: boolean;
}

export default class extends React.Component<Props, State> {
  private textarea: HTMLTextAreaElement | null = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      editing: false
    }
  }

  startEditing() {
    this.setState({editing: true}, () => {
      this.textarea?.focus();
    })
  }

  render() {
    return <>
      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between py-3">
          <div className="align-self-center">
            Notes
          </div>
          <div className="align-self-center">
            {this.state.editing
              ? <Button variant="secondary" size="sm" onClick={() => this.setState({editing: false})}>Save</Button>
              : <Button variant="primary" size="sm" onClick={() => this.startEditing()}>Edit</Button>
            }
          </div>
        </Card.Header>
        <Card.Body className={"p-0 quotationNotesCard" + (this.state.editing ? " editing" : "")}>
          <TextareaAutosize className={"p-3 quotationNotes" + (this.state.editing ? " editing" : "")} readOnly={!this.state.editing}
                            defaultValue={this.props.notes}  ref={(tag) => (this.textarea = tag)}/>
        </Card.Body>
      </Card>
    </>
  }
}